import React from "react";
import { Table, Text, Box, Alert, Button, Group, Flex } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { FifoWarningItem } from "../types/FifoWarning";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

interface FifoWarningModalProps {
    data?: FifoWarningItem[];
    onConfirm?: () => void;
    onCancel?: () => void;
}

const FifoWarningModal = ({
    data,
    onConfirm,
    onCancel,
}: FifoWarningModalProps) => {
    const handleDoubleClick = (text: string) => {
        if (text) {
            navigator.clipboard.writeText(text);
            NotificationExtension.Success(`Đã copy: ${text}`);
        }
    };

    return (
        <Box>
            {/* <Alert
                variant="light"
                color="red"
                title="Cảnh báo FIFO"
                icon={<IconAlertCircle size={16} />}
            >
                <Text size="sm" fw={500} mb={5}>
                    Nguyên tắc FIFO (First In, First Out - Nhập trước, Xuất trước) là
                    phương pháp quản lý hàng tồn kho, trong đó hàng hóa/nguyên liệu được
                    nhập vào kho trước sẽ được ưu tiên xuất ra, sử dụng hoặc bán trước.
                </Text>
                <Text size="sm">
                    Hệ thống phát hiện có những sản phẩm có tuổi tồn lâu hơn trong kho.
                    Vui lòng xem xét lựa chọn những sản phẩm này để đảm bảo nguyên tắc
                    FIFO.
                </Text>
            </Alert> */}

            <Box style={{ overflowX: "auto", maxHeight: "400px" }} mb="md">
                <Table withTableBorder withColumnBorders striped>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th
                                colSpan={3}
                                style={{ textAlign: "center", backgroundColor: "#f8f9fa" }}
                            >
                                Thông tin sp gốc
                            </Table.Th>
                            <Table.Th
                                colSpan={3}
                                style={{ textAlign: "center", backgroundColor: "#f8f9fa" }}
                            >
                                Sản phẩm đề xuất
                            </Table.Th>
                        </Table.Tr>
                        <Table.Tr>
                            <Table.Th style={{ width: "120px" }}>Mã SP</Table.Th>
                            <Table.Th style={{ width: "150px" }}>Serial</Table.Th>
                            <Table.Th style={{ width: "100px" }}>Tuổi tồn (ngày)</Table.Th>
                            <Table.Th style={{ width: "150px" }}>Serial</Table.Th>
                            <Table.Th style={{ width: "120px" }}>Mã kho</Table.Th>
                            <Table.Th style={{ width: "120px" }}>Vị trí</Table.Th>
                            <Table.Th style={{ width: "100px" }}>Tuổi tồn (ngày)</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {data?.map((item, index) => {
                            const rowCount = item.suggest?.length ?? 0;
                            return (
                                <React.Fragment key={index}>
                                    {rowCount === 0 ? (
                                        <Table.Tr>
                                            <Table.Td>
                                                <Text
                                                    color="green"
                                                    fw={600}
                                                    style={{ cursor: "pointer" }}
                                                    onDoubleClick={() => handleDoubleClick(item.itemCode)}
                                                    title="Double click để copy"
                                                >
                                                    {item.itemCode}
                                                </Text>
                                            </Table.Td>
                                            <Table.Td>
                                                <Text
                                                    color="green"
                                                    fw={600}
                                                    style={{ cursor: "pointer" }}
                                                    onDoubleClick={() => handleDoubleClick(item.serial)}
                                                    title="Double click để copy"
                                                >
                                                    {item.serial}
                                                </Text>
                                            </Table.Td>
                                            <Table.Td>
                                                <Text
                                                    color="red"
                                                    fw={600}
                                                    style={{ textAlign: "center" }}
                                                >
                                                    {item.itemAge}
                                                </Text>
                                            </Table.Td>
                                            <Table.Td
                                                colSpan={4}
                                                style={{
                                                    textAlign: "center",
                                                    fontStyle: "italic",
                                                    color: "#666",
                                                }}
                                            >
                                                Không có sản phẩm đề xuất
                                            </Table.Td>
                                        </Table.Tr>
                                    ) : (
                                        item.suggest?.map((suggestion, subIndex) => (
                                            <Table.Tr key={`${index}-${subIndex}`}>
                                                {subIndex === 0 && (
                                                    <>
                                                        <Table.Td rowSpan={rowCount} valign="middle">
                                                            <Text
                                                                color="green"
                                                                fw={600}
                                                                style={{ cursor: "pointer" }}
                                                                onDoubleClick={() => handleDoubleClick(item.itemCode)}
                                                                title="Double click để copy"
                                                            >
                                                                {item.itemCode}
                                                            </Text>
                                                        </Table.Td>
                                                        <Table.Td rowSpan={rowCount} valign="middle">
                                                            <Text
                                                                color="green"
                                                                fw={600}
                                                                style={{ cursor: "pointer" }}
                                                                onDoubleClick={() => handleDoubleClick(item.serial)}
                                                                title="Double click để copy"
                                                            >
                                                                {item.serial}
                                                            </Text>
                                                        </Table.Td>
                                                        <Table.Td
                                                            rowSpan={rowCount}
                                                            valign="middle"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            <Text color="red" fw={600}>
                                                                {item.itemAge}
                                                            </Text>
                                                        </Table.Td>
                                                    </>
                                                )}
                                                <Table.Td>
                                                    <Text
                                                        color="#40c057"
                                                        fw={600}
                                                        style={{ cursor: "pointer" }}
                                                        onDoubleClick={() => handleDoubleClick(suggestion.serial)}
                                                        title="Double click để copy"
                                                    >
                                                        {suggestion.serial}
                                                    </Text>
                                                </Table.Td>
                                                <Table.Td>
                                                    <Text color="#40c057" fw={600}>{suggestion.invCode}</Text>
                                                </Table.Td>
                                                <Table.Td>
                                                    <Text color="#40c057" fw={600}>{suggestion.positionCode}</Text>
                                                </Table.Td>
                                                <Table.Td>
                                                    <Text color="red" fw={600}>
                                                        {suggestion.inventoryAge}
                                                    </Text>
                                                </Table.Td>
                                            </Table.Tr>
                                        ))
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </Table.Tbody>
                </Table>
            </Box>
            <Flex justify="space-between">
                <Group justify="flex-end" mt="xl">
                    <Text fw={600} size="xl" c="red">Bạn có chắc chắn muốn tiếp tục không ? </Text>
                </Group>
                <Group justify="flex-end" mt="xl">
                    {onCancel && (
                        <Button variant="outline" color="gray" onClick={onCancel}>
                            Quay lại cân nhắc
                        </Button>
                    )}
                    <Button color="blue" onClick={onConfirm}>
                        Tiếp tục
                    </Button>
                </Group>
            </Flex>
        </Box>
    );
};

export default FifoWarningModal;
